module.exports = __webpack_public_path__ + "media/images/icon-history-active-6450e67fbdddc9e4a26ff29fc62fd7b9.svg";